module.exports = __webpack_public_path__ + "img/hnk-logo.4a6e5d12.png";